import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const OFFSET_SUFFIX = /(Z|[+-]\d{2}:\d{2})$/;

/** Trims fractional seconds to milliseconds so every parser reads the value the same way. */
const normalise = (value: string): string =>
  value.replace(/(\.\d{3})\d+/, '$1');

/**
 * The instant an API date-time string refers to.
 * A value without an offset is UTC, which is how the API writes its plain date-times.
 */
export const apiInstant = (value: string): Dayjs => {
  const normalised = normalise(value);
  return OFFSET_SUFFIX.test(normalised)
    ? dayjs(normalised)
    : dayjs.utc(normalised);
};

/**
 * The wall clock an API date-time string was written in, kept as is for display.
 * A value without an offset is already the organisation's local time.
 */
export const apiWallClock = (value: string): Dayjs => {
  const normalised = normalise(value);
  const match = normalised.match(OFFSET_SUFFIX);
  if (!match) {
    return dayjs(normalised);
  }
  const offset = match[1] === 'Z' ? 0 : match[1];
  return dayjs(normalised).utcOffset(offset);
};
